{
	"aiStyleInUse": "AI Style in use",
	"failedToLoadTitle": "Failed to Load Style",
	"failedToLoadMessage": "Unable to load the style. Please try again.",
	"loading": "Loading..."
}
